import { WALLET_BUTTON_ICON_CLASSNAME } from 'src/components/ConnectWalletButtonsList/WalletButton';
import useDriftTheme from 'src/hooks/useDriftTheme';
import { DriftTheme } from 'src/environmentVariables/EnvironmentVariables';
import { useAppKit } from '@reown/appkit/react';
import ConnectWalletModalButton from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalButton';

export const ReownWalletButton = () => {
	const { open: openAppKitModal } = useAppKit();

	const handleConnectReownWallet = () => {
		openAppKitModal({ view: 'Connect', namespace: 'solana' });
	};

	const isLightTheme = useDriftTheme() === DriftTheme.light;
	return (
		<ConnectWalletModalButton onClick={handleConnectReownWallet}>
			<div className={WALLET_BUTTON_ICON_CLASSNAME}>
				<img
					src={
						isLightTheme
							? '/assets/icons/reown-logo-negative.svg'
							: '/assets/icons/reown-logo.svg'
					}
					className="size-full"
				/>
			</div>
			<span>Social Login with Reown</span>
		</ConnectWalletModalButton>
	);
};
